/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Longitude_RequiredInputs */

const cs_validation_longitude_required = /** @type {(inputs: Validation_Longitude_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeměpisná délka je povinná`)
};

const en_validation_longitude_required = /** @type {(inputs: Validation_Longitude_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitude is required`)
};

/**
* | output |
* | --- |
* | "Longitude is required" |
*
* @param {Validation_Longitude_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_longitude_required = /** @type {((inputs?: Validation_Longitude_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Longitude_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_longitude_required(inputs)
	return cs_validation_longitude_required(inputs)
});